import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@aws-amplify/ui-react";
import { Amplify } from "aws-amplify";

import awsconfig from "./aws-exports";

import "@aws-amplify/ui-react/styles.css";
import 'rsuite/Avatar/styles/index.css';
import 'rsuite/Drawer/styles/index.css';
// import 'react-chatbot-kit/build/main.css'
import "rsuite/DatePicker/styles/index.css";
import 'rsuite/Modal/styles/index.css';
import 'rsuite/AutoComplete/styles/index.css';
import 'rsuite/Animation/styles/index.css';
import 'rsuite/Dropdown/styles/index.css';

import { studioTheme } from "./ui-components";
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { sessionStorage } from 'aws-amplify/utils';

Amplify.configure(awsconfig);
cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={studioTheme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
